import * as XLSX from 'xlsx-js-style';

/** Excel number format that renders hours the way the report tables do, e.g. `52.5h`. */
export const HOURS_FORMAT = '0.##"h"';
/** Excel number format for hour columns the tables always show to 2 decimals, e.g. `525.50h`. */
export const HOURS_2DP_FORMAT = '0.00"h"';
/** Excel number format that renders percentages the way the report tables do, e.g. `86%`. */
export const PERCENT_FORMAT = '0"%"';

/**
 * Bold + top-bordered styling for a sheet's totals/average footer row, mirroring
 * the on-screen totals row of the report tables.
 *
 * `rowIdx` is 0-based, so for a `json_to_sheet` sheet whose last row is the
 * totals row it is simply `rows.length` (row 0 holds the header).
 *
 * `numberFormats` maps column headers to Excel number formats, so hour and
 * percentage cells keep their numeric value but display the table's `h` / `%`
 * suffix.
 *
 * Note: the community `xlsx` build discards `cell.s`, so callers must write the
 * workbook with `xlsx-js-style`.
 */
export function styleTotalsRow(
  ws: XLSX.WorkSheet,
  cols: string[],
  rowIdx: number,
  numberFormats: Record<string, string> = {},
): void {
  cols.forEach((col, c) => {
    const addr = XLSX.utils.encode_cell({ r: rowIdx, c });
    const cell: XLSX.CellObject = ws[addr] ?? (ws[addr] = { t: 's', v: '' });
    const numFmt = typeof cell.v === 'number' ? numberFormats[col] : undefined;
    cell.s = {
      font: { bold: true },
      border: { top: { style: 'thin', color: { rgb: 'FF999999' } } },
      ...(numFmt ? { numFmt } : {}),
    };
  });
}
